import api from 'api/direct-mail';
import handleResponse from './utils/handleResponse';

export const syncWithFranconnect = () => {
    return handleResponse(
        api().get('/corporate/franconnect/sync')
    );
   
}